/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PermissionAccessData { 
    isAdmin: boolean;
    canAssignAdmin: boolean;
    canReadAnalysis: boolean;
    canReadPerformance: boolean;
    canReadHealth: boolean;
    canUploadVideo: boolean;
    canEditVideo: boolean;
}

